var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoginType } from '@lucidlink/dto/validation';
import { Box, FloatingBox } from '@lucidlink/uicore';
import { ExperimentalFeature, OpenLucidDevTools, PageHeading, UserMenuContent, UserMenuTrigger, } from '#components';
import { useAuthProvider, useDependency } from '#context';
import styles from './AppHeader.module.css';
export const AppHeader = () => {
    _react_refresh_temp_2();
    const { currentUser } = useAuthProvider();
    // eslint-disable-next-line @typescript-eslint/naming-convention -- component definition
    const SupportMenu = useDependency('SupportMenu');
    // eslint-disable-next-line @typescript-eslint/naming-convention -- component definition
    const DownloadDesktopAppLink = useDependency('DownloadDesktopAppLink');
    const isLoggedWithCode = currentUser?.loginType === LoginType.VERIFICATION_CODE;
    const isAuthenticated = Boolean(currentUser);
    return (_jsxs(Box, { align: "center", as: "header", className: styles.Container, "data-testid": "app-header", isFullWidth: true, justify: "between", kind: "level1", padding: "s m", shrink: 0, children: [_jsx(PageHeading, {}), _jsxs(Box, { align: "center", gap: "l", justify: "end", children: [_jsx(ExperimentalFeature, { children: _jsx(OpenLucidDevTools, {}) }), isAuthenticated && _jsx(SupportMenu, {}), !isLoggedWithCode && _jsx(DownloadDesktopAppLink, {}), isAuthenticated && (_jsx(FloatingBox, { Content: _jsx(UserMenuContent, {}), "data-testid": "header-user", renderTrigger: (triggerProps) => (_jsx(UserMenuTrigger, { ...triggerProps, currentUser: currentUser })) }))] })] }));
};
_react_refresh_temp_1 = AppHeader;
$RefreshReg$(_react_refresh_temp_1, "AppHeader");
_react_refresh_temp_2(AppHeader, "VYoprfP4FbCTDzbHGGjab48wlGg=", false, () => [useAuthProvider, useDependency, useDependency]);
